// 頻出語ランキングの「感情で色分け」トグル。
// 品詞色 ⇔ 感情色を切り替え、ワードクラウド・共起ネットワークには CustomEvent で通知する。
// Turbo 遷移で二重登録しないよう、リスナーは document に一度だけ付けてイベント委譲で処理する。
class SentimentColorToggle {
  constructor() {
    document.addEventListener('change', (event) => {
      if (!(event.target instanceof Element)) return

      const toggle = event.target.closest('[data-sentiment-color-toggle]')
      if (!toggle) return

      this.apply(toggle.checked ? 'sentiment' : 'hinshi')
    })
  }

  apply(mode) {
    this.paintDots(mode)
    this.switchLegend(mode)
    document.dispatchEvent(new CustomEvent('text-mining:color-mode', { detail: { mode } }))
  }

  // 表のドット・バーなど、品詞色と感情色の両方を持つ要素の背景色を差し替える
  paintDots(mode) {
    document.querySelectorAll('[data-hinshi-color][data-sentiment-color]').forEach((element) => {
      const color = mode === 'sentiment'
        ? element.getAttribute('data-sentiment-color')
        : element.getAttribute('data-hinshi-color')
      if (color) element.style.backgroundColor = color
    })
  }

  // 表示/非表示を切り替えるとカードの高さが変わり、grid で隣り合うワードクラウドの canvas が
  // リサイズされて配置が総入れ替えになる。高さを変えないよう、非アクティブ側を薄くするだけにする
  switchLegend(mode) {
    document.querySelectorAll('[data-color-legend]').forEach((legend) => {
      legend.classList.toggle('opacity-40', legend.getAttribute('data-color-legend') !== mode)
    })
  }
}

// 自動初期化
new SentimentColorToggle()
